module.exports = __webpack_public_path__ + "static/img/second4.003b6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/second4.png
// module id = 349D
// module chunks = 25